import React, { useEffect, useState } from "react";
import { CardAdmin } from "../../Componenten/Cards/CardAdmin";
import { getAdmins } from "../../Localstorage/localstorage";
import CrudEventAdmin from "../../Componenten/Calender/CrudEventAdmin";
import CrudEventAdminCalendly from "../../Componenten/Calender/CrudEventAdminCalendly";

const Admins = ({}) => {
  const admins = getAdmins();
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(null)

  const getSelected = (item) => {
      setSelected(item);
  }

  useEffect(() => {
    if(selected != null)
    setOpen(true)
  }, [selected])
  

  return (
    <div className="min-h-screen h-fit bg-wa-app p-4 sm:p-6">
      <div className="mb-4 min-w-0 flex-1">
        <h2 className="text-2xl font-bold leading-7 text-wa-text sm:truncate sm:text-3xl sm:tracking-tight">
          Onze specialitesten
        </h2>
        <p className="mt-1 text-sm text-wa-muted">
          Kies een specialist om meteen een afspraak te plannen of een bericht te sturen.
        </p>
      </div>
      <ul
        role="list"
        className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3"
      >
        {admins?.length > 0 &&
          admins.map((admin) => (
            <li
              key={admin.email}
            >
              <CardAdmin admin={admin} getSelected={getSelected} />
            </li>
          ))}
      </ul>
      <CrudEventAdminCalendly admin={selected} openModel={open} setOpenModal={setOpen}/>
    </div>
  );
};

export default Admins;
